{
 "clickScreen": {
  "1": "Klicka på rutan"
 },
 "mobileOrientation": {
  "1": "Vänd din apparat i liggande läge"
 },
 "tips": {
  "noTips": "Inga tips",
  "gameStarted": "Du har hamnat i en fälla. För att komma ut ur huset måste du hitta den bunker där trollet fabricerar falska nyheter. Genom att undersöka rummen hittar du tips som hjälper dig vidare.",
  "matrixPoster": "Märkte du den konstiga pappershögen ovanför sängen? Gå och ta dig en titt på den.",
  "solveMatrix": "Gå tillbaka till pappershögen. Dra bitarna till sina platser innanför den streckade linjen.",
  "goToTwitter": "Har du redan undersökt datorn på bordet?",
  "twitterPassword": "Undersök pusslet igen. Har trollet skrivit ett tips där?",
  "twitterExplained": "Trollet du jagar skriver lögner i sociala medier dold av en falsk profil. Om du kan avslöja trollet kommer du närmare bunkern.",
  "lockConsole": "Till höger om ståldörren i korridoren finns ett mekaniskt lås. Välj det.",
  "solveLockConsole": "Du såg tre sociala medier-profiler i datorn. Vem av dem publicerar falsk information? Med hjälp av trollets profilnamn kan du öppna låset till dörren.",
  "magazine": "Det finns någonting intressant på trollets arbetsbord.",
  "cameraLocker": "Trollet fotograferar människor i hemlighet och kan stå bakom bilden i tidningen. Någonstans här i lagret finns en kamera gömd. Märkte du skåpet brevid dörren?",
  "solveCameraLocker": "Du kan öppna skåpet med en kod. Kanske skulle du undersöka tidningen en gång till.",
  "camera": "Undersök kameran.",
  "solveClock1": "I tidningen och i kameran fanns en bild som var samma. Men någonting var bortklippt från den bild som skickades till tidningen. Det finns nu här någonstans",
  "solveClock2": "Undersök kamerans rulle. Syns där en klocka? Flytta visarna på klockan vid dörren så att de visar rätt tid.",
  "bunkerFound": "Du har hittat fram till bunkern där trollet sitter och skickar ut lögner på olika plattformar under falsk profil. Hans mål är att skapa oreda. Ditt arbete som undersökande journalist är ändå på hälft, du är inte ännu fri.",
  "controlPanel": "Ser du ledningar på golvet? Vart leder de?",
  "solveControlPanel1": "Hur ska ledningarna kopplas? Följ ledningarna och kolla in ljusen.",
  "solveControlPanel2": "Gå ännu tillbaka till elskåpet. Såg du blåa lysrör i de olika rummen? Antalet lysrör berättar i vilket hål ledningarna från de olika rummen ska kopplas.",
  "bunkerComputer": "Du kopplade  rätt. Skärmen på bordet slogs på.",
  "solveBunkerComputer": "Gå tillbaka till datorn. Allt som sägs på webben är inte sant.",
  "bunkerComputerWrong": "Undersök de olika postningarna i datorn. I vilken av dem finns en bild eller källa som verkar misstänkt. Anmäl den.",
  "warehouseComputer": "När man inte kommer vidare från bunkern finns det bara en riktning att välja.",
  "solveWarehouseComputer": "Bilder säger inte alltid sanningen och man kan vilseleda folk med dem.",
  "warehouseComputerWrong": "Undersök postningarna i datorn, och speciellt bilderna. Tre av dem har manipulerats. Anmäl dem.",
  "flatComputer": "Det fanns visst en dator också i det första rummet?",
  "solveFlatComputer": "För bra för att vara sant? Ta bort onödiga löften.",
  "flatComputerWrong": "Gå ännu tillbaka till datorn. Bara ett av meddelandena är äkta. Resten hör i skräpkorgen.",
  "safariPoster": "Du fick ett nytt meddelande i e-posten. Månne du hittar något tips där för att komma vidare.",
  "safariPoster2": "Tutki seinällä olevaa leijonajulistetta. Sen takana saattaa olla jotain."
 },
 "loading": {
  "1": "3D-modellen laddas...",
  "2": "Färdigladdad",
  "3": "Ännu ett ögonblick… Spelet startar",
  "4": "Bilderna laddas...",
  "5": "Alla bilder laddade."
 },
 "start": {
  "1": "Du stiger in och dörren stängs bakom dig. Du inser att du har hamnat i en fälla.",
  "2": "Du är en undersökande journalist och har fått ett tips om att det finns en trollfabrik i det här ödehuset. En trollfabrik som sprider falska nyheter.",
  "3": "Hur ska du ta dig ut?",
  "4": "Framåt",
  "5": "Du kan ta i föremål och utforska dem genom att gå nära och klicka på dem.",
  "6a": "Rör dig",
  "6b": "Snurra runt",
  "7a": "Du får fram kursorn genom att trycka på",
  "7b": "-tangenten",
  "8a": "BÖRJA",
  "8b": "FRAMÅT"
 },
 "twitter": {
  "1": "Lösenord",
  "2": "Logga in",
  "3": "Stäng",
  "4": "Tillgång nekad",
  "5": "Godkänt",
  "6": "Ett ögonblick...",
  "7": "Välkommen!",
  "Name1": "Minna",
  "Name2": "Olli Korhonen",
  "Name3": "jHg",
  "NickName1": "minna_banana",
  "NickName2": "OlliTheOrange",
  "NickName3": "Meloni_6745792",
  "Desc1": "Mamma, fru, hundmänniska, lärare och hobbyodlare. Tweetar på svenska.",
  "Desc2": "Akutvårdare som rör sig i naturen på många sätt: fotvandring, orientering och geocaching. Ofta tillsammans med efterkommande.",
  "Desc3": "",
  "Following": "Följer",
  "Followers": "Följare",
  "Follow": "Följ",
  "Joined": "Gick med",
  "Hashtag1": "vaccin",
  "message1": "Finland rekommenderar alla myndigheter att man tar vaccin. Marsch iväg!<span class=\"twitterHashtags\">#immunitet  #hälsa</span>",
  "message2": "Vågar ni ge influensavaccin åt era barn? Om man plötsligt får narkolepsi av det :( <span class=\"twitterHashtags\"><b> #vaccin</b></span> Fast kanske man borde ta. Lite skrämmande.",
  "message3": "Nu är det bestämt: vi ska få en ny hundvalp i familjen. Ljuuuvligt!  ❤️❤️❤️ <span class=\"twitterHashtags\">#hundfeber #nyfamiljemedlem #inlove",
  "message4": "Finska lärare är fantastiska, trots all press",
  "message5": "Efterlyses: En systemkamera. Rekommendationer? Pris max 1000 e. Användning främst naturfoton men ska också funka vid fotisplanen :o)",
  "message6": "3542 människor har dött i Estland pga vaccinering! Tänk på vad för skräp de matar i dig! <span class=\"twitterHashtags\"><b>#vaccin #influensa #konspiration</b></span> bit.ly/p/skdjKSDisjd...",
  "news": "NYHET",
  "tweetsTotal": "tweetar",
  "newsHeader": "Det finns inte tid för tillräcklig växelverkan",
  "newsHeader2": "Icke-brådskande fall belastar akutvårdeni"
 },
 "infoScreen": {
  "closeWindow": "Stäng",
  "header": "TROLLBUNKERN",
  "game": "Trollbunkern är ett digitalt escape room, som lär dig mediekunskap.",
  "Desktop": "Du rör dig i huset med hjälp av musen, piltangenterna eller med tangenterna WASD. Du kan ta i föremål och utforska dem genom att gå nära och klicka på dem. Du får fram kursorn genom att trycka på esc.",
  "Mobile": "På mobilen rör du dig genom att rulla på de synliga kontrollrundlarna",
  "feedback": "Vi blir glada över all feedback. Skicka dina synpunkter till exempel till <a href=\"mailto:vetamix@yle.fi\">vetamix@yle.fi</a> eller <a href=\"mailto:oppiminen.palaute@yle.fi\">oppiminen.palaute@yle.fi</a>",
  "creditsHeader": "Arbetsgrupp"
 },
 "facebook": {
  "messageHeader": "Vi förhåller oss allvarligt till falska nyheter. Tack för att du hjälper oss!",
  "message": "Du kan anmäla bara en av de här tre nyheterna. Ditt val är:",
  "confirm_button": "Anmäl",
  "cancel_button": "Ångra",
  "cta_button": "Anmäld",
  "cta_pressed_button": "Anmäl nyheten",
  "posts": {
   "first": {
    "name": "Solvi Saikkonen",
    "message": "Snåla fåglar!",
    "linkUrl": "yle.fi",
    "linkHeader": "Konstigt problem på mjölkkogårdar: Talgoxarna pickar på kornas juver",
    "linkDesc": "I Simo i södra Lappland har man under vintern upptäckt ett konstigt fågelproblem. Talgoxar som hade kommit in i lagården har pickat sår i kornas juver. På grund av såren har man till och med varit tungna att avliva kor. Maaseudun tuevaisuus rapporterade först om nyheten. Enligt tidningen känner man till tre fall."
   },
   "second": {
    "name": "Seppo Äs",
    "message": "Ganska hisnande nyheter från Venedig!",
    "linkUrl": "sidubara.com",
    "linkHeader": "I Venedig åker man nu skridsko på kanalerna!",
    "linkDesc": "Den snabba klimatförändringen ställer till det på många håll i Europa. I Venedig vaknade man på tisdagen till en ovanlig syn när alla stadens kanaler var täckta av is. Eftersom gondolerna har frusit fast kan folk inte gå på jobb. Många utnyttjar tiden till att åka skridsko längs kanalerna."
   },
   "third": {
    "name": "Taru Aapkari",
    "message": "Vågar du ännu le?",
    "linkUrl": "hs.fi",
    "linkHeader": "“Årsringarna” i våra tandrötter berättar om vändpunkter i våra liv.",
    "linkDesc": "I våra tänder, eller närmare bestämt i tandcementet, finns information om när en kvinna har fött barn eller när klimakteriet började. På tandcementets yta ser man också spår av långvarig stress och till och med år i fängelse, om man har råkat ut för sådant i sitt liv. Prövningarna syns som ljusare partier, lite som tillväxten syns på årsringarna på ett träd."
   }
  }
 },
 "framegram": {
  "message": "Kära användare, sanningshalten på innehållet är viktig för oss. Vi hoppas att du anmäler innehåll som du upplever som opålitligt.",
  "ok": "ok",
  "reported": "Anmälda",
  "kpl": "st",
  "posts": {
   "first": {
    "name": "KimaS",
    "message": "Första gången på länge! Och det gick helt bra. Skulle kanske löna sig att slå foten oftare :D <b>#instasports #martialarts</b>"
   },
   "second": {
    "name": "pave_xe",
    "message": "Jag hittade min nya favoritprotein, Muskel-Vita Pro  med det och regelbunden meditation har massan ökat massor!"
   },
   "third": {
    "name": "matsmek",
    "message": "Vi gjorde en jääättelång promenad idag med Mimi och nu börjar vi laga mat. Härlig lördagkväll åt alla &lt;3  <b>#runda #hundrunda #lördag #weekend #dog #dogsofinstagram #doglovers #doglife #bae #koiruli #nature #sports #mimi #saturday</b>"
   },
   "fourth": {
    "name": "gmeyrham",
    "message": "Sprid budet! Paraidrottare X åker på ett ben. Förra veckan blev han av med sin sista sponsor och nu har han inte råd att åka och tävla till Alperna. Hjälp honom med en liten donation på konto CE11435-23595"
   },
   "fifth": {
    "name": "llizzy_loe",
    "message": "Jag skulle så kunna flytta hit! Sova på golvet och njuta av de här SKATTERNA.🎶 ❤ 🎧 🎶<b>#lovemusic #instamusic  #skivaffär</b>"
   },
   "sixth": {
    "name": "li4lah",
    "message": "Tack till alla som kom och hörde oss! Spelningen var slutsåld och det var helt fullt!"
   },
   "seventh": {
    "name": "a.m.o.n.e.",
    "message": "🌴 ☀ 🍹 🌴 <b>#instatravel #vacation #holidaymood</b>"
   }
  },
  "likes": "likes",
  "report": "Anmäl"
 },
 "email": {
  "notification": {
   "header": "Du har ett nytt e-postmeddelande",
   "source": "Julistekauppa.net",
   "address": "kundtjänst@julistekauppa.net",
   "text": "Bedöm din produkt"
  },
  "moveToTrash": "Flytta valda i skräpkorgen",
  "cancelAction": "Returnera e-post",
  "title6": "Risk Free",
  "title5": "Bonus 500e",
  "title4": "Dåligt nyheter",
  "title3": "Tilläggsåtgärd",
  "title2": "Din beställning är postad",
  "title1": "Om din donation",
  "shopName": "Kiikarikauppa.com",
  "shopAddress": "<a href=\"mailto:kundtjanst@kiikarikauppa.com\">kundtjanst@kiikarikauppa.com</a>",
  "error": "System error! You need to select five messages.",
  "mail1": {
   "1": "Jag heter Marc B. Jackson JR. och vann Powerball-jättevinsten på 344,6 miljoner dollar den 4 juni 2020.",
   "2": "Jag gör en donation till fem slumpmässigt utvalda e-postadresser, och din adress är en som jag har valt till lotteriet. Jag donerar 1 000 000 euro till dig och din familj utan baktankar.",
   "3": "Ta kontakt med mig via e-post <a href=\"mailto:marcjacksonjr85@bmail.com\">marcjacksonjr85@bmail.com</a> för att få din donation."
  },
  "mail2": {
   "1": "Bästa kund,",
   "2": "Kiikarikauppa.com tilauksesi on nyt postitettu lähetystunnuksella din beställning från kiikarikauppa.com är nu postad med försändelsekod <b>JJFI6147051898801</b>. Du kan följa din beställning på postens webbplats.",
   "3": "Du beställde 1x “Powerpro kikare”",
   "4": "Om det är något problem med din beställning så svara på detta meddelande.",
   "5": "Vänliga hälsningar,"
  },
  "mail3": {
   "1": "Bästa kund,",
   "2": "Vi måste tyvärr meddela att leveransen av ditt paket misslyckades.<br />",
   "3": "Uppföljningsnummer"
  },
  "mail4": {
   "1": "Hej,",
   "2": "Jag har dåliga nyheter åt dig!<br /> Jag har hackat ditt operativsystem och har tillgång till dina textmeddelanden, e-postmeddelanden och foton och dem vill jag börja skicka till alla dina kontakter (vänner. släktingar och arbetskamrater) för att förstöra ditt rykte. Jag har dokumenterat dig otaliga gånger med din egen webbkamera och också hört på dina diskussioner via webbkameran.",
   "3": "Jag kan få dig att förlora dina vänner, dina arbetskamrater och ditt jobb.",
   "4": "KLICKA HÄR"
  },
  "mail5": {
   "1": "Gratulation,<br /> Vi har glädjen att meddela att du är en av de få utvalda som får den här unika  möjligheten att få det här erbjudandet: 500€ BONUS!",
   "2": "Missa inte den här chansen!",
   "3": "KLICKA HÄR"
  },
  "mail6": {
   "1": "I am very sorry in reaching out to you without a consent proper authorization, but I think it's wise for me to share  with you a business proposal of $18M about your last name for an investment transaction which is 100% risk free if interested please reply my email: <b><u>kufo.1217@bmail.com</u></b>"
  },
  "newMail1": "Bästa kund",
  "newMail2": "Bedöm din produkt och vinn ett presentkort.",
  "newMail3": "Du beställde 1x “Retro-savann-affisch”",
  "newMail4": "Vänliga hälsningar,"
 },
 "endingScreen": {
  "title": "Jättefint! Strålande!",
  "timeSpent": "Du klarade dig ut ur trollets bunker på tiden",
  "linkText": "Läs mera om hur du känner igen falska nyheter på",
  "link": "<a href=\"https://svenska.yle.fi/nyhetsskolan\">https://svenska.yle.fi/nyhetsskolan</a>",
  "recommend": "Tipsa en kompis:",
  "shareText": "Jag lyckades ta mig ut ut trollets bunker. Lyckas du?"
 },
 "landingPage": {
  "openInBrowser": "Öppna spelet i browsern",
  "link": "https://link.yle.fi/trollbunkern",
  "copied": "Kopierad"
 }
}